<template>
	<div>
		<div class="l-event">
			<div :class="{ 'l-event__head': fromListEvent, 'bg-transparent': true }">
				<div class="l-list-menu">
					<div class="l-list-menu__tab">
						<slot />
						<div :class="{ 'l-deal-and-shop': fromListEvent, 'pt-12 pb-50': true }">
							<div class="l-deal-and-shop__title d-flex pt-12 pb-12">
								<div></div>
								<div class="l-deal_view-all">
									<switch-favorite :isFavorite="isFavorite" :toggleFavorite="toggleFavorite" />
								</div>
							</div>
							<div class="c-list-deal__item" v-if="events.length == 0">
								ただいま掲載中の情報はありません
							</div>
							<div class="c-list-deal">
								<div class="c-list-deal__items">
									<div v-for="(event, index) in events" :key="event.id + index"
										class="swiper-slide c-list-deal__item--wrap"
										v-show="!isFavorite || (favoriteEventExists(event.id) && isFavorite)">
										<div class="c-list-deal__item">
											<div v-on:click="openModalDetail(event)" class="c-list-deal__img js-keep-ratio"
												data-ratio="0.746">
												<img v-lazy="getImgSrc(event.image && event.image[0])" alt="" />
											</div>
											<div class="c-list-deal__info">
												<div @click.prevent="shopTop(event.provider)" class="c-news__shop"
													v-if="event.provider && event.provider.id != SHOP_ID">
													<div v-if="event.provider && event.provider.id"
														class="c-news__shop--name">
														<span class="c-tag--number"
															v-if="event.provider && event.provider.floorGuideNo">{{
																truncatedShopName(event.provider &&
																	event.provider.floorGuideNo, 3) }}</span>
														<span>{{ event.provider.shopName }}</span>
													</div>
													<div v-else class="c-news__shop--name">
														<span>{{ event.provider && event.provider.name }}</span>
													</div>
												</div>
												<div class="c-news__shop" v-else>
													<div class="c-news__shop--name aeon-all">
														イオンタウンイベント
													</div>
												</div>
												<div class="event-title">{{ event.title }}</div>
												<div @click.self="openModalDetail(event)"
													class="c-list-deal__info--content c-list-deal__info--title line-clamp-hack c-list-deal__info--title--shop">
													<div class="c-list-event__time">
														<span v-html="formatEventTerm2(event)"></span>
														<br/>
														{{ event.provider && event.provider.location }}
													</div>
													<favorite-icon :isActive="favoriteEventExists(event.id)"
														:toggleFavorite="() => toggleFavoriteEvent(event)" />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal :open="openModal" @close="() => {
			openModal = false;
			if (fromListEvent) this.$router.push({ query: {} });
			else this.$router.go(-1);
		}">
			<event-detail :eventId="eventId" :eventProviderId="eventProviderId" :toggleFavoriteEvent="(e) => toggleFavoriteEvent(e)" :isActive="favoriteEventExists" @navigateBack="() => this.navigateBack(fromListEvent)"/>
		</modal>
	</div>
</template>
<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import SwitchFavorite from "../components/SwitchFavorite.vue";
import FavoriteIcon from "../components/FavoriteIcon.vue";
import Modal from "../components/Modal.vue";
import EventDetail from "../views/EventDetail.vue";
import { formatEventTerm2, getImgSrc, truncatedShopName } from "../utils";
import { EVENT_COLLECTION_KEY } from "../config/const";
import { Tenant } from "../plugin/mixin";
import { Common } from "../common/common";
export default Vue.extend({
	name: "EventList",
	components: {
		SwitchFavorite,
		FavoriteIcon,
		Modal,
		EventDetail,
	},
	mixins: [Tenant],
	props: {
		events: {
			type: Array,
			required: true,
			default: () => [],
		},
		setEventList: {
			type: Function,
			required: false,
		},
		initialTab: {
			type: Number,
			required: false,
			default: 0,
		},
		queryIdKey: {
			type: String,
			required: false,
			default: 'id'
		},
		queryProviderIdKey: {
			type: String,
			required: false,
			default: 'providerId'
		},
		fromListEvent: {
			type: Boolean,
			required: false,
			default: true
		},
	},
	data() {
		return {
			isFavorite: false,
			pageFade: false,
			openModal: false,
			eventProviderId: '',
			eventId: '',
			SHOP_ID: null,
			EVENT_COLLECTION_KEY,
		};
	},
	computed: {
		eventList() {
			return this.initialTab === 0 ? this.eventTodayList : this.data;
		},
	},
	watch: {
		'$route.query': {
			handler: function (newVal) {
				if (!newVal[this.queryIdKey]) {
					this.openModal = false
					return;
				}
				this.eventId = newVal[this.queryIdKey]
				this.eventProviderId = newVal[this.queryProviderIdKey] ?? this.$store.getters.shopId
				this.openModal = true
			},
			immediate: true
		}
	},
	created() {
		this.SHOP_ID = this.$store.getters.shopId
	},
	updated() {
		this.$nextTick(function () {
			Common.setKeepRatio()
		})
	},
	methods: {
		formatEventTerm2,
		getImgSrc,
		truncatedShopName,
		toggleFavorite() {
			this.isFavorite = !this.isFavorite;
		},
		openModalDetail(event) {
			const listQuery = !this.fromListEvent ? {
				...this.$route.query,
				[`${this.queryIdKey}`]: event.id,
				[`${this.queryProviderIdKey}`]: event.provider && event.provider.id
			} : {
				[`${this.queryIdKey}`]: event.id,
				[`${this.queryProviderIdKey}`]: event.provider && event.provider.id
			}
			this.$router.push({ query: listQuery })
		},
		toggleFavoriteEvent(event) {
			if (this.favoriteEventExists(event.id)) {
				this.deleteFavorite(event, EVENT_COLLECTION_KEY, event.provider);
			} else {
				this.addFavorite(event, EVENT_COLLECTION_KEY, event.provider);
			}
		},
	},
});
</script>
